import React, { useEffect, useState, useMemo } from 'react';
import { Card, Table, Tag, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { createAuthApi } from '@zero/auth-admin-ui';
import { useGridPageSize, GRID_PAGE_SIZE_OPTIONS } from '../../hooks/useGridPageSize.js';

const { Text } = Typography;

export function PermissionsPage({ axios }) {
  const api = useMemo(() => createAuthApi(axios), [axios]);
  const { t } = useTranslation();
  const [perms, setPerms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useGridPageSize('permissions', 25);

  useEffect(() => {
    setLoading(true);
    api.listPermissions().then((r) => setPerms(r.data?.Data ?? [])).finally(() => setLoading(false));
  }, [api]);

  const columns = [
    { title: 'Module',                  dataIndex: 'Module',   width: 100 },
    { title: t('permission.code'),      dataIndex: 'Code',     render: (v) => <Text code>{v}</Text>, sorter: (a,b) => a.Code.localeCompare(b.Code) },
    { title: 'Resource',                dataIndex: 'Resource' },
    { title: 'Action',                  dataIndex: 'Action',   width: 100 },
    { title: 'DisplayKey',              dataIndex: 'DisplayKey', render: (v) => <Text code style={{ fontSize: 11 }}>{v}</Text> },
    { title: 'Translated',              key: 'translated', render: (_, p) => t(p.DisplayKey, { defaultValue: p.Code }) },
    { title: 'Status',                  dataIndex: 'IsObsolete', width: 100, render: (v) => v ? <Tag color="warning">Obsolete</Tag> : <Tag color="success">{t('common.active')}</Tag> },
  ];

  return (
    <Table dataSource={perms} columns={columns} loading={loading} rowKey="PermissionID" size="small" bordered
           pagination={{
             pageSize,
             showSizeChanger: true,
             pageSizeOptions: GRID_PAGE_SIZE_OPTIONS,
             onShowSizeChange: (_, size) => setPageSize(size),
           }}
           scroll={{ y: 'calc(100vh - 130px)' }} />
  );
}
